<template>
  <div>
    <div class="iqos-grid">
      <div class="iqos-column">
        <!-- <MenuContentType v-if="!hideMenuSettings" /> -->

        <WhiteIQOS required :subtitle="atLeastOneModeActive
                ? $t('menu_settings.select_mode')
                : $t('menu_settings.no_modes')
                " :title="$t('menu_settings.systems')" v-if="!hideMenuSettings">
          <div class="gap-row-1xs">
            <IQOSModeToggle noColor noBlackSwitcher mode="preview" v-model="tagPreview"
              v-if="!canShowToggle('inside') && canShowToggle('preview')" />
            <BaseDivider color="v1-grey-3"
              v-if="!canShowToggle('inside') && (canShowToggle('preorder') || canShowToggle('delivery'))" />
            <IQOSModeToggle mode="inside" noColor noBlackSwitcher v-model="tagInside" v-if="canShowToggle('inside')" />
            <BaseDivider color="v1-grey-3"
              v-if="canShowToggle('inside') && (canShowToggle('preorder') || canShowToggle('delivery'))" />
            <IQOSModeToggle mode="preorder" noColor noBlackSwitcher v-model="tagPreorder"
              v-if="canShowToggle('preorder')" />
            <BaseDivider color="v1-grey-3" v-if="canShowToggle('preorder') && (canShowToggle('delivery'))" />
            <IQOSModeToggle mode="delivery" noColor noBlackSwitcher v-model="tagDelivery"
              v-if="canShowToggle('delivery')" />
            <BaseDivider color="v1-grey-3" v-if="cafe.reserve.use_superapp" />
            <IQOSModeToggle mode="reserve" noColor noBlackSwitcher v-model="tagNewReserve"
              v-if="cafe.reserve.use_superapp" />
            <IQOSModeToggle mode="hotels" noColor noBlackSwitcher v-model="tagHotels" v-if="canShowToggle('hotels')" />
          </div>
          <!-- <small :class="atLeastOneModeActive ? '' : 'pt-0 mt-0'">{{

          }}</small> -->
        </WhiteIQOS>

        <MenuPayReceiver v-if="!hideMenuSettings" />

        <TaxSelector v-model="menuTaxId" />
      </div>

      <div class="iqos-column">
        <MenuShowExclusivesPanel v-if="!hideMenuSettings" />
        <MenuTagPanel v-if="!hideMenuSettings" />
        <!-- <PosterPendingChanges :menu_id="menu._id" v-if="hasPosterIntegration" /> -->
        <PosterMissingDishes @showEditor="onMenuEdit" :menu="menu" v-if="hasPosterIntegration" />



        <MenuScheduleEditor v-if="!hideMenuSettings" />
      </div>
    </div>

    <DangerConfirmModal @cancel="deleting = false" @confirm="onMenuDelete" v-if="deleting">{{
                $t("menu_settings.confirm_delete") }}</DangerConfirmModal>

    <InfoModal @close="integration_delete_modal = false" v-if="integration_delete_modal">{{ $t("menu_settings.poster")
      }}</InfoModal>
  </div>
</template>

<script>
import MenuScheduleEditor from "@/components/schedule/MenuScheduleEditor.vue";

import InfoModal from "@/components/modals/InfoModal.vue";
import MenuContentType from "@/components/menu/MenuContentType.vue";

import MenuTagPanel from "@/components/menu/MenuTagPanel.vue";
import MenuAPI from "@/api/menu";
import CafeAPI from "@/api/cafe";

import MenuShowExclusivesPanel from "@/components/menu/MenuShowExclusivesPanel.vue";

import MenuPayReceiver from "@/components/menu/MenuPayReceiver.vue";
import TaxSelector from "@/components/menu/TaxSelector.vue";

import PosterPendingChanges from "@/components/integrations/PosterPendingChanges.vue";
import PosterMissingDishes from "@/components/integrations/PosterMissingDishes.vue";

export default {
  data () {
    return {
      addMenu: false,
      editing: false,
      deleting: false,

      tag_edit: {
        active: false,
        tag: null,
      },

      title_edit: {
        active: false,
        title: null,
      },

      discount_edit: {
        active: false,
        value: null,
      },
      integration_delete_modal: false,

      preview_token: null,
    };
  },
  props: {
    menu: Object,
  },
  methods: {
    canShowToggle (mode) {
      if (mode == "inside" && this.cafe.inside_lite) return true;
      return !this.hideMenuSettings && this.$store.state.cafe.modes[mode] && this.$store.getters.checkBillingPlanForPaidService(
        mode === 'preorder' ? 'takeaway' : mode
      );
    },
    showDeleteUI () {
      // if (this.isIntegrationMenu) {
      //   this.integration_delete_modal = true;
      //   return;
      // }
      this.deleting = true;
    },
    onMenuDelete () {
      this.$store.commit("removeMenuFromModes", this.menu._id);
      this.$store.commit("removePosterMenu", this.menu._id);
      this.$store.dispatch("saveCafe");
      this.$store.dispatch("menu/remove", this.menu._id);
      this.$emit("unselect");
      this.deleting = false;
    },
    onMenuDuplicate () {
      const new_title = `${this.menu.title} ${this.$t(
        "menu_settings.duplicate_suffix"
      )}`;
      this.$store.dispatch("menu/duplicate", {
        menu_id: this.menu._id,
        title: new_title,
      });
    },
    onMenuEdit () {
      this.$emit("edit");

      if (this.$store.getters.hasPosterIntegration) {
        this.$store.dispatch("poster/fetchProductsList");
      }
    },

    showTagEditUI () {
      this.tag_edit.active = true;

      this.tag_edit.tag = this.menu.tag;
    },
    showTitleEditUI () {
      this.title_edit.active = true;

      this.title_edit.title = this.menu.title;
    },
    saveTitle () {
      if (!this.title_edit.title) return;

      this.title_edit.active = false;

      this.$store.commit("menu/setMenuTitle", {
        menu_id: this.menu._id,
        title: this.title_edit.title,
      });
      this.$store.dispatch("menu/save");
    },
    saveTag () {
      this.tag_edit.active = false;

      this.$store.commit("menu/setMenuTag", {
        menu_id: this.menu._id,
        tag: this.tag_edit.tag,
      });
      this.$store.dispatch("menu/save");
    },
    showDiscountEditUI () {
      this.discount_edit.active = true;

      this.discount_edit.value = this.menu.discount || 0;
    },
    saveDiscount () {
      this.discount_edit.active = false;

      this.$store.commit("menu/setMenuDiscount", {
        menu_id: this.menu._id,
        discount: this.discount_edit.value,
      });
      this.$store.dispatch("menu/save");
    },
  },
  mounted () { },
  components: {
    InfoModal,
    MenuScheduleEditor,
    MenuTagPanel,
    MenuContentType,
    MenuShowExclusivesPanel,
    MenuPayReceiver,
    PosterPendingChanges,
    TaxSelector,
    PosterMissingDishes,
  },
  computed: {
    cafe () {
      return this.$store.state.cafe;
    },
    isHotel () {
      return this.$store.getters.isHotel;
    },
    isIntegrationMenu () {
      return this.cafe.poster && this.cafe.poster.menu_id == this.menu._id;
    },
    hideMenuSettings () {
      if (this.cafe && this.cafe.poster) {
        if (this.cafe.poster.menu_id == this.menu._id)
          return !(
            this.tagInside ||
            this.tagPreorder ||
            this.tagDelivery ||
            this.tagHotels ||
            this.tagPreview
          );
      }

      return this.menu.is_example;
    },
    isInsideLiteEnabled () {
      return this.cafe.inside_lite && !this.cafe.modes.inside;
    },
    atLeastOneModeActive () {
      return true;
    },
    hasPosterIntegration () {
      return this.$store.getters.hasPosterIntegration;
    },
    tagInside: {
      get () {
        return this.$store.getters["menu/menuModes"](this.menu._id).inside;
      },
      set (v) {
        if (this.$store.state.selected_chain) {
          this.$store.commit("setChainModeMenu", {
            mode: "inside",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveChain");
        } else {
          this.$store.commit("setCafeModeMenu", {
            mode: "inside",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveCafe");
        }

        if (v) {
          this.$store.commit("menu/enableModeForAllProducts", {
            mode: "inside",
          });
          this.$store.dispatch("menu/save");
        }

        CafeAPI.setMenuMode(this.cafe._id, this.menu._id, "inside", v);

        this.$store.dispatch("auditlog/write", {
          type: "menu_toggle",
          payload: {
            menu_id: this.menu._id,
            title: this.menu.title,
            mode: "inside",
            value: v,
          },
        });
      },
    },
    tagPreorder: {
      get () {
        return this.$store.getters["menu/menuModes"](this.menu._id).preorder;
      },
      set (v) {
        if (this.$store.state.selected_chain) {
          this.$store.commit("setChainModeMenu", {
            mode: "preorder",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveChain");
        } else {
          this.$store.commit("setCafeModeMenu", {
            mode: "preorder",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveCafe");
        }

        if (v) {
          this.$store.commit("menu/enableModeForAllProducts", {
            mode: "preorder",
          });
          this.$store.dispatch("menu/save");
        }

        CafeAPI.setMenuMode(this.cafe._id, this.menu._id, "preorder", v);

        this.$store.dispatch("auditlog/write", {
          type: "menu_toggle",
          payload: {
            menu_id: this.menu._id,
            title: this.menu.title,
            mode: "preorder",
            value: v,
          },
        });
      },
    },
    tagDelivery: {
      get () {
        return this.$store.getters["menu/menuModes"](this.menu._id).delivery;
      },
      set (v) {
        if (this.$store.state.selected_chain) {
          this.$store.commit("setChainModeMenu", {
            mode: "delivery",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveChain");
        } else {
          this.$store.commit("setCafeModeMenu", {
            mode: "delivery",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveCafe");
        }

        if (v) {
          this.$store.commit("menu/enableModeForAllProducts", {
            mode: "delivery",
          });
          this.$store.dispatch("menu/save");
        }

        CafeAPI.setMenuMode(this.cafe._id, this.menu._id, "delivery", v);

        this.$store.dispatch("auditlog/write", {
          type: "menu_toggle",
          payload: {
            menu_id: this.menu._id,
            title: this.menu.title,
            mode: "delivery",
            value: v,
          },
        });
      },
    },
    tagHotels: {
      get () {
        return this.$store.getters["menu/menuModes"](this.menu._id).hotels;
      },
      set (v) {
        if (this.$store.state.selected_chain) {
          this.$store.commit("setChainModeMenu", {
            mode: "hotels",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveChain");
        } else {
          this.$store.commit("setCafeModeMenu", {
            mode: "hotels",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveCafe");
        }

        if (v) {
          this.$store.commit("menu/enableModeForAllProducts", {
            mode: "hotels",
          });
          this.$store.dispatch("menu/save");
        }

        CafeAPI.setMenuMode(this.cafe._id, this.menu._id, "hotels", v);

        this.$store.dispatch("auditlog/write", {
          type: "menu_toggle",
          payload: {
            menu_id: this.menu._id,
            title: this.menu.title,
            mode: "hotels",
            value: v,
          },
        });
      },
    },
    tagPreview: {
      get () {
        return this.$store.getters["menu/menuModes"](this.menu._id).preview;
      },
      set (v) {
        if (this.$store.state.selected_chain) {
          this.$store.commit("setChainModeMenu", {
            mode: "preview",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveChain");
        } else {
          this.$store.commit("setCafeModeMenu", {
            mode: "preview",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveCafe");
        }

        if (v) {
          this.$store.commit("menu/enableModeForAllProducts", {
            mode: "preview",
          });
          this.$store.dispatch("menu/save");
        }

        CafeAPI.setMenuMode(this.cafe._id, this.menu._id, "preview", v);

        this.$store.dispatch("auditlog/write", {
          type: "menu_toggle",
          payload: {
            menu_id: this.menu._id,
            title: this.menu.title,
            mode: "preview",
            value: v,
          },
        });
      },
    },
    tagNewReserve: {
      get () {
        return this.cafe.reserve.menu_id === this.menu._id;
      },
      set (v) {
        //TODO: fix later!
        if (this.$store.state.selected_chain) {
          this.$store.commit("setChainModeMenu", {
            mode: "reserve",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveChain");
        } else {
          this.$store.commit("setCafeModeMenu", {
            mode: "reserve",
            menu_id: this.menu._id,
            active: !!v,
          });
          this.$store.dispatch("saveCafe");
        }

        CafeAPI.setMenuMode(this.cafe._id, this.menu._id, "reserve", v);

        this.$store.dispatch("auditlog/write", {
          type: "menu_toggle",
          payload: {
            menu_id: this.menu._id,
            title: this.menu.title,
            mode: "reserve",
            value: v,
          },
        });
      },
    },
    menuTaxId: {
      get () {
        return this.$store.state.menu.current.tax_id;
      },
      set (v) {
        this.$store.commit("menu/setMenuTax", v);
        this.$store.dispatch("menu/save");

        this.$store.dispatch("auditlog/write", {
          type: "change_menu_tax",
          payload: {
            menu_id: this.menu._id,
            title: this.menu.title,
            tax_id: v,
          },
        });
      },
    },
  },
};
</script>


<style scoped>
.settings-buttons {
  display: flex;
  margin-bottom: 3vh;
  position: fixed;
  z-index: 3;
  right: 1.2vh;
  top: 5.5vh;
}

.settings-title h3 {
  font-weight: 500;
  font-size: 2.6vh;
  color: #fff;
}

.settings-body {
  border-top: 1px solid #a4a3a1;
  width: 100%;
  margin-top: 3.3vh !important;
}

small {
  padding-top: 2vh;
  display: block;
  font-size: 1.8vh;
  color: #908f8d;
}

.btn-dashboard {
  font-size: 1.6vh;
  border: none;
  width: 100%;
  cursor: pointer;
  color: #ededed;
  display: block;
  border-radius: 0.5vh;
  padding: 0.5vh 1vh;
}

.green {
  background: #129b81;
}

.settings-buttons button {
  border: 0;
  font-family: "Roboto";
  font-weight: 400;
  font-size: 1.8vh;
  color: #1d1d1d;
  padding: 0.5vh 1vh;
  margin-right: 2.2vh;
  outline: none;

  cursor: pointer;
}

.settings-buttons button:nth-child(3) {
  margin-right: 0;
}

h4 {
  font-size: 2.6vh;
}

.w-20 {
  width: 20vh;
}

.bg-transparent {
  text-align: left;
  line-height: normal;
  border: none;
  background: transparent;
}

.bg-transparent,
.edit-tagname {
  font-size: 2.7vh;
  font-weight: bold;
  font-family: "Chadwick";
}

.delivery,
.smart-recommendations {
  margin-bottom: 3.3vh;
}

.inside,
.preorder,
.delivery,
.preview-control {
  /* width: 54.5vh; */
  width: 100%;
  padding: 0 2.3vh 0 0;
  position: relative;
}

.preview-control {
  display: flex;
  align-items: center;
}

.preview-control p {
  display: flex;
  align-self: center;
  padding: 2vh;
  margin: 0;
  color: #908f8d;
}

.inside h2,
.preorder h2,
.delivery h2 {
  font-size: 2.3vh;
  line-height: normal;
  padding: 1vh 0;
  color: #c4c4c4;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  /* transition: 0.2s;     */
}

.inside p,
.preorder p,
.delivery p {
  font-size: 1.7vh;
  line-height: normal;

  color: #a5a5a5;

  margin: 1.2vh 0 0;

  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.smart-recommendations {
  max-width: 22.3vw;
}

.smart-recommendations select {
  margin-bottom: 1vw;

  width: 100%;
  font-family: Roboto;
  font-weight: 600;
  font-size: 1.3vw;
  height: 2.5vw;
  display: flex;

  color: #262626;

  border-radius: 0.3vw;
  border: 0;

  padding-left: 0.8vw;

  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  background: url(../../assets/arrow.png) no-repeat 96% center;
  background-color: #c4c4c4;
  background-size: 1.3vw;

  outline: none;
}

option {
  background: #e3e3e3;
}

.smart-recommendations h3 {
  font-family: Roboto;
  font-weight: 500;
  font-size: 1.3vw;
  margin-bottom: 1.3vw;

  color: #c4c4c4;
}

.smart-recommendations p {
  font-family: Roboto;
  font-size: 0.9vw;
  line-height: 130.8%;
  color: #a5a5a5;
}

.pro {
  background: #59a5ff;
  border-radius: 0.3vw;
  border: 0;

  font-family: Roboto;
  font-weight: 500;
  font-size: 1.3vw;

  color: #ffffff;

  padding: 0.4vw 1.7vw 0.4vw 1.7vw;
  cursor: pointer;

  /* transition: 0.3s; */
  outline: none;
  display: flex;
}

.pro:hover {
  color: #59a5ff;
  background: #fff;
}

#checkbox:checked~h2 {
  color: #ffffff;
  transition: 0.2s;
}

#checkbox2:checked~h2 {
  color: #ffffff;
  transition: 0.2s;
}

#checkbox3:checked~h2 {
  color: #ffffff;
  transition: 0.2s;
}

#checkbox4:checked~h2 {
  color: #ffffff;
  transition: 0.2s;
}

::-webkit-scrollbar {
  width: 0px !important;
  background: transparent !important;
}

html {
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}

.tag-container {
  margin-bottom: 2vh;
  width: 54.5vh;
}

.edit-tagname {
  line-height: 1;
  padding-left: 1vh;
  font-size: 2.7vh;
}

.tag-edit-button {
  width: auto;
  height: 3.4vh;
  margin-bottom: 1vh;
  margin-left: 0.6vh;
  float: right;
  cursor: pointer;
}

.gray-label {
  font-size: 1.8vh;
  line-height: 1;
  width: 100%;
  color: #a5a5a5;
  padding: 2vh 0 2vh;

  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.preview-qr {
  border-radius: 1.2vh;
  height: 18vh;
  width: 18vh;
  min-width: 18vh;
  min-height: 18vh;
  border: 2vh solid white;
}

.invalid-input {
  border: 2px solid #e2223b;
  outline: none;
}
</style>
